import React, {FC, useCallback, useState} from 'react'
import {FormHelperText, IconButton, InputAdornment, InputLabel, OutlinedInput} from '@mui/material'
import Clear from '@mui/icons-material/Clear'
import {useFormContext, useWatch} from 'react-hook-form'
import {StyledFormControl} from '../styled'
import {useSearchPublicationByDeprecatedIdLazyQuery} from './gql/SearchPublication.generated'
import {RHF_SEARCH_PUBLICATION_CONSTS} from './RHFSearchPublication.consts'
import {ButtonWrapper, RHFSearchPublicationWrapper} from './RHFSearchPublication.styles'

const RHFSearchPublication: FC = () => {
  const [url, setUrl] = useState('')
  const [error, setError] = useState('')
  const [deprecatedId, setDeprecatedId] = useState('')

  const {control} = useFormContext()
  const fields = useWatch({control})

  const [searchPublication] = useSearchPublicationByDeprecatedIdLazyQuery({
    fetchPolicy: 'cache-and-network',
    onCompleted: data => {
      fields.onAdded(data.publicationByDeprecatedId)
    }
  })

  const handleSetUrlErrors = useCallback((url: string) => {
    setUrl(url)
    setError('')

    const match = url.match(RHF_SEARCH_PUBLICATION_CONSTS.publicationRegexp1)

    const deprecatedIdVal = match ? url.replace(RHF_SEARCH_PUBLICATION_CONSTS.publicationRegexp2, '') : ''

    if (!deprecatedIdVal) {
      setError(RHF_SEARCH_PUBLICATION_CONSTS.incorrectLink)
      setDeprecatedId('')
      return
    }
    setDeprecatedId(deprecatedIdVal)
  }, [])

  const getOldId = useCallback(() => {
    try {
      if (deprecatedId) {
        console.log('deprecatedId', deprecatedId)
        searchPublication({
          variables: {deprecatedId: +deprecatedId}
        })
      }
    } catch {}

    setUrl('')
  }, [searchPublication, deprecatedId])

  return (
    <RHFSearchPublicationWrapper>
      <StyledFormControl width='100%'>
        <InputLabel>{RHF_SEARCH_PUBLICATION_CONSTS.publicationLink}</InputLabel>
        <OutlinedInput
          label={RHF_SEARCH_PUBLICATION_CONSTS.publicationLink}
          onChange={e => handleSetUrlErrors(e.target.value)}
          value={url}
          error={!!error}
          endAdornment={
            <InputAdornment position='end'>
              {url && (
                <IconButton edge='end' size='small' onClick={() => handleSetUrlErrors('')}>
                  <Clear fontSize='small' />
                </IconButton>
              )}
            </InputAdornment>
          }
        />
        <FormHelperText>{error}</FormHelperText>
      </StyledFormControl>
      <ButtonWrapper variant='contained' color='primary' disabled={!deprecatedId || !!error} onClick={getOldId}>
        {RHF_SEARCH_PUBLICATION_CONSTS.add}
      </ButtonWrapper>
    </RHFSearchPublicationWrapper>
  )
}

export default RHFSearchPublication
